/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LanguageCommunication
 */
export interface LanguageCommunication {
    /**
     * 
     * @type {string}
     * @memberof LanguageCommunication
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageCommunication
     */
    label: string;
}

/**
 * Check if a given object implements the LanguageCommunication interface.
 */
export function instanceOfLanguageCommunication(value: object): value is LanguageCommunication {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function LanguageCommunicationFromJSON(json: any): LanguageCommunication {
    return LanguageCommunicationFromJSONTyped(json, false);
}

export function LanguageCommunicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageCommunication {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'label': json['label'],
    };
}

export function LanguageCommunicationToJSON(value?: LanguageCommunication | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'label': value['label'],
    };
}

